import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-bordered" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header min-h-50px" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Keys")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = { class: "col-2" }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = { class: "col-9" }
const _hoisted_8 = ["onUpdate:modelValue"]
const _hoisted_9 = { class: "col-1" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "svg-icon svg-icon-3" }
const _hoisted_12 = { class: "d-flex justify-content-center my-5" }
const _hoisted_13 = { class: "svg-icon svg-icon-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Add key", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.keyList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "row align-items-center my-2 min-w-400px"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                "onUpdate:modelValue": ($event: any) => ((item.weight) = $event),
                class: "form-control form-control-solid",
                name: "permision"
              }, null, 8, _hoisted_6), [
                [_vModelText, item.weight]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((item.key) = $event),
                class: "form-control form-control-solid fs-8",
                placeholder: "Enter public key"
              }, null, 8, _hoisted_8), [
                [_vModelText, item.key]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-icon badge-light-danger btn-color-danger btn-sm me-1",
                onClick: ($event: any) => (_ctx.remove(index))
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                ])
              ], 8, _hoisted_10)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-light-primary d-flex align-items-center",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addKey()))
          }, [
            _createElementVNode("span", _hoisted_13, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr075.svg" })
            ]),
            _hoisted_14
          ])
        ])
      ])
    ])
  ]))
}